import { MenuAll } from "./menu.model";

export const Menu:MenuAll[] = [
    {
        id: 1,
        icon: 'fa-house-chimney',
        link: 'main',
    },
    {
        id: 2,
        icon: 'fa-calendar-days',
        link: 'detailsite',
    },
    {
        id: 3,
        icon: 'fa-chart-pie',
        link: '',
    },
    {
        id: 4,
        icon: 'fa-gear',
        link: '',
    },
]
